import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translations/en.json';
import se from './translations/se.json';
import de from './translations/de.json';

const supportedLanguages = ['de', 'en', 'se'];

const fallbackLng = 'de';

const detectLanguageFromDomain = () => {
    const hostRegexMap: { [key: string]: RegExp } = {
        de: /^de\.|\.de$/,
        en: /^en\.|\.en$/,
        se: /^se\.|\.se$/,
    };

    const hostname = window.location.hostname;
    const language = Object.keys(hostRegexMap).find((key) => hostRegexMap[key].test(hostname));
    return language;
};

const getLanguageFromEnv = () => {
    const language = process.env.LNG || fallbackLng;
    return supportedLanguages.includes(language) ? language : fallbackLng;
};

const detectLanguage = () => {
    const language = detectLanguageFromDomain() ?? getLanguageFromEnv();
    return supportedLanguages.includes(language) ? language : fallbackLng;
};

i18n.use(initReactI18next).init({
    lng: detectLanguage(),
    fallbackLng: fallbackLng,
    debug: process.env.STAGE === 'dev',

    // Normally, we want `escapeValue: true` as it ensures that i18next escapes any code in
    // translation messages, safeguarding against XSS (cross-site scripting) attacks. However,
    // React does this escaping itself, so we turn it off in i18next.
    interpolation: {
        escapeValue: false,
    },

    resources: {
        de: {
            translation: de,
        },
        en: {
            translation: en,
        },
        se: {
            translation: se,
        },
    },
});

export default i18n;
